const components = [
	{
		name: 'inDevelopment',
		title:"开发中",
		component: './components/public/inDevelopment',
		icon:'#icon-gas_station'
	},{
		name: 'equipmentMonitoring',
		title:"设备状态",
		component: './components/OperationMonitoring/stationMonitoring/EqumentStatus',
		icon:'#icon-gas_station'
	},{
		name: 'equipmentStatus',
		title:"设备状态",
		component: './components/OperationMonitoring/stationMonitoring/EqumentStatusList',
		icon:'#icon-gas_station'
	},{
		name: 'equmentStatusInternal',
		title:"设备状态",
		component: './components/OperationMonitoring/stationMonitoring/EqumentStatusInternal',
		icon:'#icon-gas_station'
	},{
		name: 'equmentOfflineLog',
		title:"设备离线日志",
		component: './components/OperationMonitoring/stationMonitoring/EqumentOfflineLog',
		icon:'#icon-gas_station'
	},{
		name: 'parkingLockStatus',
		title:"设备状态",
		component: './components/OperationMonitoring/stationMonitoring/ParkingLockStatus',
		icon:'#icon-gas_station'
	},{
		name: 'powerModuleInfo',
		title:"模块状态",
		component: './components/OperationMonitoring/PowerModuleInfo/PowerModuleInfo',
		icon:'#icon-gas_station'
	},{
		name: 'powerModuleRecord',
		title:"模块状态",
		component: './components/OperationMonitoring/PowerModuleInfo/PowerModuleRecord',
		icon:'#icon-gas_station'
	},{
		name: 'incomeMonitoring',
		title:"收入监控",
		component: './components/OperationMonitoring/stationMonitoring/IncomeMonitor',
		icon:'#icon-leijishouru'
	},{
		name: 'electricMonitoring',
		title:"用电监控",
		component: './components/OperationMonitoring/stationMonitoring/DeviceStatus',
		icon:'#icon-icon-monitor'
	},{
		name: 'realMonitoring',
		title:"实时充电",
		component: './components/OperationMonitoring/ChargingMonitoring/ChargingInfo',
		icon:'#icon-yongdianfenxi'
	},{
		name: 'alarmMonitoring',
		title:"实时告警",
		component: './components/OperationMonitoring/ChargingMonitoring/AlarmingInfo',
		icon:'#icon-alarm'
	},{
		name: 'alarmRrecord',
		title:"告警记录",
		component: './components/Maintenance/Maintenance/AlarmRecord',
		icon:'#icon-ALARM'
	},{
		name: 'networkEvent',
		title:"事件记录",
		component: './components/Archives/EventManagement/EquipNetworkEvents/EquipNetworkEvents',
		icon:'#icon-event'
	},{
		name: 'repairRecord',
		title:"故障报修",
		component: './components/Maintenance/FaultReport/FaultReport',
		icon:'#icon-alarm'
	},{
		name: 'mapMonitoring',
		title:"地图监控",
		component: './components/OperationMonitoring/MapMonitoring/MapMonitoring',
		icon:'#icon-ditu'
	},{
		name: 'chargeOrder',
		title:"充电订单",
		component: './components/OrderMonitoring/OrderRecord/ChargingOrder',
		icon:'#icon-dingdan'
	},{
		name: 'evcsOrders',
		title:"互联互通订单",
		component: './components/OrderMonitoring/OrderRecord/EvcsChargeOrder',
		icon:'#icon-24gl-receipt'
	},{
		name: 'occupyOrder',
		title:"占位订单",
		component: './components/OrderMonitoring/OccupyOrder/OccupyOrder',
		icon:'#icon-dingdan'
	},{
		name: 'invalidOrders',
		title:"无效订单",
		component: './components/OperationMonitoring/OrderRecord/DeviceStatus',
		icon:'ios-speedometer'
	},{
		name: 'exceptionOrders',
		title:"异常订单",
		component: './components/OrderMonitoring/OrderRecord/AbnormalOrder',
		icon:'#icon-lixianjisuan'
	},{
		name: 'manualSettleOrder',
		title:"充电订单",
		component: './components/OrderMonitoring/OrderRecord/ManualSettleOrder',
		icon:'#icon-dingdan'
	},{
		name: 'chargeRecord',
		title:"充电记录",
		component: './components/OrderMonitoring/ChargeRecord/ChargeRecord',
		icon:'#icon-quanju_shengji'
	},{
		name: 'chargeRecordInternal',
		title:"充电记录",
		component: './components/OrderMonitoring/ChargeRecord/ChargeRecordInternal',
		icon:'#icon-quanju_shengji'
	},{
		name: 'offlineRecord',
		title:"离线卡记录",
		component: './components/OrderMonitoring/OfflineCardRecord/OfflineCardRecord',
		icon:'#icon-lixian'
	},{
		name: 'invoiceMgr',
		title:"发票管理",
		component: './components/OrderMonitoring/InvoiceInfo/InvoiceInfoManagement',
		icon:'#icon-lixian'
	},{
		name: 'stationAnalysis',
		title:"场站分析",
		component: './components/StatisticalAnalysis/OperationalAnalysis/StationAnalysis',
		icon:'#icon-tongjifenxi3'
	},{
		name: 'stationAnalysisEvcs',
		title:"互联互通分析",
		component: './components/StatisticalAnalysis/OperationalAnalysis/StationAnalysisEvcs',
		icon:'#icon-tongjifenxi3'
	},{
		name: 'stationReports',
		title:"场站报表",
		component: './components/StatisticalAnalysis/OperationalAnalysis/StationReports',
		icon:'#icon-tongjifenxi3'
	},{
		name: 'stationReportsEvcs',
		title:"互联互通报表",
		component: './components/StatisticalAnalysis/OperationalAnalysis/StationReportsEvcs',
		icon:'#icon-tongjifenxi3'
	},{
		name: 'onlineRatio',
		title:"在线率",
		component: './components/StatisticalAnalysis/EfficiencyAnalysis/OnlineRateInfo/OnlineRateInfo',
		icon:'ios-speedometer'
	},{
		name: 'useRatio',
		title:"利用率",
		component: './components/StatisticalAnalysis/EfficiencyAnalysis/UseRateInfo/UseRateInfo',
		icon:'ios-speedometer'
	},{
		name: 'attritionRatio',
		title:"损耗率",
		component: './components/OperationMonitoring/stationMonitoring/DeviceStatus',
		icon:'ios-speedometer'
	},{
		name: 'memberInfo',
		title:"会员信息",
		component: './components/Member/IndividualMember/MemberInfo',
		icon:'#icon-qinghuiyuan'
	},{
		name: 'memberTransRecord',
		title:"会员交易记录",
		component: './components/Member/IndividualMember/TransactionRecordInfo',
		icon:'#icon-shouru'
	},{
		name: 'memberStatistics',
		title:"会员统计",
		component: './components/Member/MemberStatistics/MemberStatisticsInfo',
		icon:'#icon-shouru'
	},{
		name: 'memberGroupInfo',
		title:"集团信息",
		component: './components/Member/GroupMember/GroupMemberInfo',
		icon:'#icon-huiyuanqia'
	},{
		name: 'memberGroupTransRecord',
		title:"集团交易记录",
		component: './components/Member/GroupMember/GroupTransactionRecordInfo',
		icon:'#icon-shouru'
	},{
		name: 'stationManage',
		title:"场站管理",
		component: './components/Archives/StationManagement/StationManagement',
		icon:'#icon-chongdianzhuang'
	},{
		name: 'equipmentManageCar',
		title:"设备管理(汽车)",
		component: './components/Archives/EquipmentManagement/EquipmentManagementCar',
		icon:'#icon-linshiyongdianjiebo'
	},{
		name: 'equipmentManageMoto',
		title:"设备管理(电单车)",
		component: './components/Archives/EquipmentManagement/EquipmentManagementMoto',
		icon:'#icon-linshiyongdianjiebo'
	},{
		name: 'equipmentManageParkingLock',
		title:"设备管理(地锁)",
		component: './components/Archives/EquipmentManagement/EquipmentManagementParkingLock',
		icon:'#icon-linshiyongdianjiebo'
	},{
		name: 'equipmentModelManage',
		title:"设备型号管理",
		component: './components/Archives/EquipmentManagement/EquipmentModelManage',
		icon:'#icon-linshiyongdianjiebo'
	},{
		name: 'periodPriceManagement',
		title:"价格管理",
		component: './components/Archives/PriceManagement/PriceManagement',
		icon:'#icon-icon-price'
	},{
		name: 'powerPriceManagement',
		title:"电单车价格",
		component: './components/Archives/PriceManagement/PriceManagementPower',
		icon:'#icon-icon-price'
	},{
		name: 'occupyPriceManagement',
		title:"占位费价格",
		component: './components/Archives/PriceManagement/PriceManagementOccupy',
		icon:'#icon-icon-price'
	},{
		name: 'merchantMgr',
		title:"商户管理",
		component: './components/Archives/MerchantManagement/MerchantManagement',
		icon:'#icon-icon-price'
	},{
		name: 'eventManage',
		title:"事件管理",
		component: './components/Archives/EventManagement/EventManagement',
		icon:'#icon-yuanquyunwei'
	},{
		name: 'couponManage',
		title:"优惠券管理",
		component: './components/OperationMonitoring/CouponMonitoring/CouponManagement',
		icon:'#icon-iconmoban'
	},{
		name: 'localOperatorMgr',
		title:"运营商管理",
		component: './components/Archives/OperatorManageMent/OperatorManageMent',
		icon:'#icon-yunyingshang'
	},{
		name: 'evcsOperatorsMgr',
		title:"互联互通运营商",
		component: './components/Archives/OperatorManageMent/EvcsOperatorManageMent',
		icon:'#icon-yunyingshang'
	},{
		name: 'parametersManagement',
		title:"设备参数管理",
		component: './components/Archives/ParametersManagement/ParametersManagement',
		icon:'#icon-yunyingshang'
	}, {
		name: 'boardArchives',
		title: '主板档案',
		component: './components/BoardManagement/BoardArchives/BoardArchives',
		icon:'#icon-yunyingshang'
	}, {
		name: 'boardTestRecord',
		title: '主板测试记录',
		component: './components/BoardManagement/BoardTestRecord/BoardTestRecord',
		icon:'#icon-yunyingshang'
	}, {
		name: 'boardTestRecordPCBA',
		title: '主板测试记录(贴片厂)',
		component: './components/BoardManagement/BoardTestRecord/BoardTestRecordPCBA',
		icon:'#icon-yunyingshang'
	}, {
		name: 'personalInfo',
		title:"个人信息",
		component: './components/SysMonitoring/PersonalInformation/PersonalInformation',
		icon:'ios-speedometer'
	},{
		name: 'roleManage',
		title:"角色管理",
		component: './components/SysMonitoring/RoleManagement/RoleManagement',
		icon:'#icon-quanxianguanli1'
	},{
		name: 'userManage',
		title:"用户管理",
		component: './components/SysMonitoring/UserManagement/UserManagement',
		icon:'#icon-renyuanguanli1'
	},{
		name: 'menuManage',
		title:"菜单管理",
		component: './components/SysMonitoring/MenuManagement/MenuManagement',
		icon:'#icon-quanxianguanli3'
	},{
		name: 'widgetManage',
		title:"控件管理",
		component: './components/SysMonitoring/ControlManagement/ControlManagement',
		icon:'#icon-update'
	},{
		name: 'remoteUpgrade',
		title:"远程升级",
		component: './components/SysMonitoring/RemoteUpgrade/RemoteUpgrade',
		icon:'#icon-quanju_shengji'
	},{
		name: 'firmwareMgr',
		title:"固件管理",
		component: './components/SysMonitoring/RemoteUpgrade/FirmwareMgr',
		icon:'#icon-quanju_shengji'
	},{
		name: 'equipDiagnostics',
		title:"日志召测",
		component: './components/SysMonitoring/DiagnosticsLogs/EquipDiagnostics',
		icon:'#icon-quanju_shengji'
	},{
		name: 'onlineRecord',
		title:"充电记录",
		component: './components/SysMonitoring/RemoteUpgrade/RemoteUpgrade',
		icon:'#icon-quanju_shengji'
	}
];

export default components
